// extracted by mini-css-extract-plugin
export var resizer = "_cv-0";